export const anchors = {
  howItWorks: 'wie-es-funktioniert',
  advantages: 'vorteile',
  hausHeldPromise: 'hausheld-versprechen',
  myHausHeld: 'myhausheld',
  clients: 'kunden',
  becomeAPartner: 'jetzt-partner-werden',
  moreRequests: 'mehr-kundenanfragen',
  faq: 'faq',
  contactDetails: 'kontakt-details',
  contactForm: 'kontakt-formular',
  furtherProjects: 'weitere-branchen',
  freeTest: 'kostenlos-testen',
  partnerForm: 'partner-formular',
  firstImpressions: 'erste-eindruecke',
  team: 'team',
  hausHeldUniverse: 'hausheld-universum',
  wirPartner: 'wir-partner-werden',
  wirForm: 'wir-formular',
  partnershipForm: 'anmelde-formular',
  findYourHero: 'wunschhelden-finden',
  quickCheck: 'quick-check',
  mortgageFaq: 'hypothek-faqs',
  sponsoringForm: 'ratgeber-formular',
  services: 'dienstleistungen',
  generator: 'generator',
  experts: 'die-experten',
  citations: 'zitate',
  mortgageCheck: 'hypo-check',
  vibe: 'vibe',
  mortgageConsulting: 'rabatt',
  propertyCalculator: 'jetzt-berechnen',
}
